export default __webpack_public_path__ + "static/media/3.6e2f05c6.jpg";